module.exports = __webpack_public_path__ + "lya.svg?4be313ec3a5ef3e5198f462935c40b8c";